import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { RadioButton, RadioButtonGroup } from 'material-ui';

class TransportModeRadioGroupSelector extends Component {
  constructor(props) {
    super(props);
    if (props.selected && props.selected.length) {
      props.onSelect(props.selected);
    }
  }

  handleChange = (event) => {
    this.props.onSelect([event.target.value]);
  };

  render() {
    return (
      <div className="selector-wrapper">
        <div className="selector-header">
          <h3 className="selector-title">{this.props.title}</h3>
        </div>
        <div className="selector-list">
          <div className="radio-group-tree">
            <RadioButtonGroup
              onChange={this.handleChange}
              name={this.props.title}
              valueSelected={this.props.selected.length ? this.props.selected[0] : ''}
            >
              {this.props.nodes.map(node => (
                <RadioButton
                  value={node.value}
                  label={node.label}
                  key={node.value}
                />
              ))}
            </RadioButtonGroup>
          </div>
        </div>
      </div>
    );
  }
}

export default TransportModeRadioGroupSelector;

TransportModeRadioGroupSelector.propTypes = {
  title: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
  nodes: PropTypes.arrayOf(PropTypes.object),
  selected: PropTypes.arrayOf(PropTypes.string),
};
